/**
 * Same heuristic as SchedulingToolPanel: backend plan / tier errors that should open
 * PlanRestrictionContactModal instead of an error snackbar.
 */
export function isEnterprisePlanRestrictionMessage(message: string): boolean {
  const m = message.toLowerCase();
  if (m.includes('enterprise')) return true;
  return false;
}

export function isEnterprisePlanRestrictionError(error: unknown): boolean {
  if (error instanceof Error) {
    return isEnterprisePlanRestrictionMessage(error.message);
  }
  return false;
}
